import { render, staticRenderFns } from "./EntityFieldDetailedView.vue?vue&type=template&id=5f164cb6&scoped=true"
import script from "./EntityFieldDetailedView.vue?vue&type=script&lang=js"
export * from "./EntityFieldDetailedView.vue?vue&type=script&lang=js"
import style0 from "./EntityFieldDetailedView.vue?vue&type=style&index=0&id=5f164cb6&prod&scoped=true&lang=css"
import style1 from "./EntityFieldDetailedView.vue?vue&type=style&index=1&id=5f164cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f164cb6",
  null
  
)

export default component.exports